import { ServiceRecords } from '@/service/records/serviceRecords'

const serviceRecords = new ServiceRecords()
export default {
  namespaced: true,
  state: {
    anamnese: {
      complaint: '',
      hpma: '',
      personal_historic: '',
      family_history: '',
      physical_exam: '',
    },
  },
  getters: {
    getAnamnese(state) {
      return state.anamnese
    },
  },
  mutations: {
    setAnamnese(state, data) {
      state.anamnese = data
    },
    updateAnamneseField(state, { field, value }) {
      state.anamnese[field] = value
    },
  },
  actions: {
    async saveAnamnese({ commit }, { recordId, data }) {
      const response = await serviceRecords.recordUpdate(recordId, data)
      commit('setAnamnese', {
        complaint: response.data.complaint,
        hpma: response.data.hpma,
        personal_historic: response.data.personal_historic,
        family_history: response.data.family_history,
        physical_exam: response.data.physical_exam,
      })
    },
    async loadAnamnese({ commit }, recordId) {
      const response = await serviceRecords.recordById(recordId)
      const data = {
        complaint: response.complaint,
        hpma: response.hpma,
        personal_historic: response.personal_historic,
        family_history: response.family_history,
        physical_exam: response.physical_exam,
      }
      commit('setAnamnese', data)
      return data
    },
  },
}
